import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** Exactly one of `interviewId` / `documentId` / `importedDocumentId` is set. `replacesDocumentTypeId` replaces (or fills) the automatically carried document of that type. */
class AddWorkflowRunSource {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly runId: number,
		public readonly interviewId: number | null,
		public readonly documentId: number | null,
		public readonly importedDocumentId: number | null,
		public readonly replacesDocumentTypeId: number | null,
	) {
		Object.freeze(this);
	}

	/** Absent fields are omitted, never sent as `null`: the server reads each as optional. */
	toJSON(): Record<string, unknown> {
		const body: Record<string, unknown> = {};

		if (this.interviewId !== null) {
			body.interviewId = this.interviewId;
		}

		if (this.documentId !== null) {
			body.documentId = this.documentId;
		}

		if (this.importedDocumentId !== null) {
			body.importedDocumentId = this.importedDocumentId;
		}

		if (this.replacesDocumentTypeId !== null) {
			body.replacesDocumentTypeId = this.replacesDocumentTypeId;
		}

		return body;
	}
}

export default AddWorkflowRunSource;
